// This file should contain any functions that utilizes `@lib/utils/date.utils` so that we have track of dayjs leaks in our codebase

import { REFERRAL_POPUP_DURATION } from '@lib/constants/common'
import date from '@lib/utils/date.utils'
import {
  getFromLocalStorage,
  setToLocalStorage,
} from '@lib/utils/local-storage'
import { Dayjs } from 'dayjs'

export const getDifference = (startTime: string | Date | Dayjs) => {
  const differenceObj = {
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  }
  const start = date(startTime)
  const now = date()

  if (start.isAfter(now)) {
    const diffInMilliseconds = start.diff(now)

    // Convert milliseconds into days, hours, minutes, and seconds
    const days = Math.floor(diffInMilliseconds / (24 * 60 * 60 * 1000))
    const hours = Math.floor(
      (diffInMilliseconds % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    )
    const minutes = Math.floor(
      (diffInMilliseconds % (60 * 60 * 1000)) / (60 * 1000)
    )
    const seconds = Math.floor((diffInMilliseconds % (60 * 1000)) / 1000)

    // Format each component to ensure two digits
    differenceObj.days = days.toString().padStart(2, '0')
    differenceObj.hours = hours.toString().padStart(2, '0')
    differenceObj.minutes = minutes.toString().padStart(2, '0')
    differenceObj.seconds = seconds.toString().padStart(2, '0')
  }

  return differenceObj
}

const saveDateInLocalStorage = (date: Date) => {
  setToLocalStorage('referralPopUpDate', date.toISOString(), () =>
    console.error('error saving date')
  )
}

export const checkForMonthlyDuration = () => {
  try {
    const currDate = new Date()
    const currDay = currDate.getDate()
    const currMonth = currDate.getMonth() + 1
    const currYear = currDate.getFullYear()
    const dateString = getFromLocalStorage('referralPopUpDate')

    if (dateString) {
      const previousShownDay = parseInt(date(dateString).format('D'))
      const previousShownMonth = parseInt(date(dateString).format('M'))
      const previousShownYear = parseInt(date(dateString).format('YYYY'))

      const dayDiff =
        (currYear - previousShownYear) * 365 +
        (currMonth - previousShownMonth) * 30 +
        (currDay - previousShownDay)

      if (dayDiff >= REFERRAL_POPUP_DURATION) {
        saveDateInLocalStorage(currDate)
        return true
      }
      // when user accidentaly sets system date ahead of the actual date
      //and that date gets saved in the local storage. Then this conditional will
      //reset the date in the local storage when the user changes system date to actual date.
      else if (dayDiff < 0) {
        saveDateInLocalStorage(currDate)
        return true
      }
      return false
    } else {
      saveDateInLocalStorage(currDate)
      return true
    }
  } catch (error) {
    console.error(error)
    return false
  }
}

export const isClassOngoing = (startDate: string, endDate: string) => {
  return date().isAfter(date(startDate)) && endDate === null
}
